import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';
import { getDistinctSourceNames } from '../../../app/admin/services/JobSearchEmulatorServices';

export const OfferSourceSelectBase = remoteOptionSelectFactory({
   getSuggestionsPromise: getDistinctSourceNames,
});
export default withSelectFormik(withInputErrorMessage(OfferSourceSelectBase));
